import {gsap} from 'gsap';
export let lib = {
    playingCards: {
        createTimeline(container) {
            let cards = container.querySelectorAll('.anim_playing-cards-item:not(:last-child)');
            let timeline = gsap.timeline({paused: true});
            timeline
                .set(cards[0], {y: '15%'})
                .set(cards[1], {y: '10%'})
                .set(cards[2], {y: '5%'})
                .to(cards, {duration: 3, y: 0, ease: 'none'}, 0);
            return timeline;
        },
        fromTo: ['top-bottom', 'bottom-top']
    },
    ring: {
        createTimeline(container) {
            let shine = container.querySelectorAll('.anim_ring-shine');
            let timeline = gsap.timeline({paused: true});
            timeline.set(shine, {opacity: 1}).fromTo(
                shine,
                {opacity: 1},
                {
                    duration: 1,
                    keyframes: [
                        {opacity: 1, ease: 'none'},
                        {opacity: 0, ease: 'none'},
                        {opacity: 1, ease: 'none'}
                    ],
                    repeat: 3
                }
            );
            return timeline;
        },
        fromTo: ['top-bottom', 'bottom-top']
    },
    lattice: {
        createTimeline(container) {
            let hor = container.querySelectorAll('.anim_lattice-hor'),
                lock = container.querySelectorAll('.anim_lattice-lock'),
                lockHand = container.querySelectorAll('.anim_lattice-lock-hand');

            let timeline = gsap.timeline({paused: true});
            timeline
                .set(hor, {x: '-100%'})
                .set(lock, {y: '100%', rotate: 0})
                .set(lockHand, {y: 0})
                .fromTo(hor, {x: '-100%'}, {duration: 1, x: 0}, 0)
                .to(lock, {duration: 1, keyframes: [{y: '100%'}, {y: '10%', rotate: 0}, {y: '-5%', rotate: 7, transformOrigin: '50% 50%'}]}, 1)
                .fromTo(lockHand, {y: 0}, {duration: 0.6, y: '-15%'}, 1.4)
                .fromTo(lock, {y: '-5%', rotate: 7, transformOrigin: '50% 50%'}, {duration: 0.3, y: 0, rotate: 0, transformOrigin: '50% 50%'}, 2)
                .fromTo(lockHand, {y: '-15%'}, {duration: 0.3, y: 0}, 2);

            return timeline;
        },
        fromTo: ['top-bottom', 'middle-middle']
    },
    female: {
        createTimeline(container) {
            let scream = container.querySelectorAll('.anim_female-scream');
            let timeline = gsap.timeline({paused: true});
            timeline.set(scream, {scale: 0, transformOrigin: '0% 50%'}).to(scream, {
                keyframes: [{scale: 0}, {scale: 1, transformOrigin: '0% 50%'}, {scale: 0}],
                repeat: 3
            });

            return timeline;
        },
        fromTo: ['top-bottom', 'top-top']
    },
    tunes: {
        createTimeline(container) {
            let notes = container.querySelectorAll('.anim_tunes-note');
            let timeline = gsap.timeline({paused: true});
            timeline.set(notes, {x: 288}).fromTo(notes, {x: 288}, {x: 0, duration: 1, stagger: {each: 1}});

            return timeline;
        },
        fromTo: ['bottom-bottom', 'top-top']
    },
    bricks: {
        createTimeline(container) {
            let bricks = container.querySelectorAll('.anim_brick');
            let timeline = gsap.timeline({paused: true});
            timeline
                .set(bricks, {y: '-50%', opacity: 0})
                .fromTo(bricks, {y: -20, opacity: 0}, {duration: 1, y: 0, opacity: 1, stagger: {each: 0.4, from: 'end'}});
            return timeline;
        },
        fromTo: ['top-bottom', 'middle-middle']
    },
    default: {
        createTimeline(container) {
            let timeline = gsap.timeline({paused: true});
            timeline.fromTo(container, {opacity: 0}, {opacity: 1, ease: 'none'}, 0);
            return timeline;
        },
        fromTo: ['bottom-bottom', 'top-top']
    }
};
